import { withStyles } from '@material-ui/core/styles';
import ImageBox from './ImageBox';
import styles from './ImageBox.styles';

export default withStyles(styles)(ImageBox);
